import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Receipt Text Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-receipt-text-outline',
    templateUrl: './icon-receipt-text-outline.component.html',
    styleUrls: ['./icon-receipt-text-outline.component.scss'],
    standalone: false
})
export class IconReceiptTextOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
